import { useDispatch, useSelector } from "react-redux";
import { FormRegion } from "../../../../components/formregion";
import { Field } from "@progress/kendo-react-form";
import { FormDropDownList, FormInput } from "../../../../forms/form-components";
import { useEffect } from "react";
import { timeIntervalsDDL } from "../../../../redux/slices/createdatasetpageslice";
import { CollapsableFormRegion } from "../../../../components/collapsableformregion";
import DatasetSample from "../../importdataset/formsteps/datasetsample";
import { setFormValue } from "../../../../redux/slices/importdatasetpageslice";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const ReviewStep = (props) => {
  const { values } = props;
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.importDatasetPage);
  const currentTheme = useSelector((state) => state.currentTheme);
  const formValues = pageState.formValues;
  const NumberOfRows = pageState.formValues.NumberOfRows;
  const { t } = useTranslation();

  useEffect(() => {}, [NumberOfRows]);

  return (
    <FormRegion>
      <div className="error-list" id="error-list">
        {pageState.error_lst?.map((e) => (
          <div key={e.Code}>
            <span style={{ color: `${currentTheme.error}` }}>{e.Code}: </span>
            {e.Message}
          </div>
        ))}
      </div>
      <div className="k-form-field">
        <label className="k-label k-text-disabled">{t("datasets.importdataset.selected")}</label>
        <div className="k-form-field-wrap">
          <input
            disabled={true}
            name="SelectedDataset"
            id="SelectedDataset"
            className="k-input k-input-md k-rounded-md k-input-solid"
            value={
              pageState.lst_of_datasets.find(
                (option) =>
                  option.Id === Number(pageState.formValues.SelectedDataset)
              )?.Title
            }
            style={{ marginBottom: "15px" }}
          />
        </div>
      </div>
      {formValues.ImportFrom === "fromdb" && (
        <div className="form-group form-group-1">
          <Field
            id={"DatabaseType"}
            name={"DatabaseType"}
            label={t("datasets.importdataset.datatype1")}
            component={FormInput}
            disabled
          />
          <Field
            id={"Server"}
            name={"Server"}
            label={t("datasets.importdataset.server1")}
            component={FormInput}
            disabled
          />
          <Field
            id={"Database"}
            name={"Database"}
            label={t("datasets.importdataset.database1")}
            component={FormInput}
            disabled
          />
          {formValues.ChooseFrom === "table" && (
            <Field
              id={"Table"}
              name={"Table"}
              label={t("datasets.importdataset.selected2")}
              component={FormInput}
              disabled
            />
          )}
          {formValues.ChooseFrom === "query" && (
            <Field
              id={"Query"}
              name={"Query"}
              label={t("datasets.importdataset.query")}
              component={FormInput}
              disabled
            />
          )}

          <div className="k-form-field">
            <label className="k-label k-text-disabled">{t("datasets.importdataset.rows")}</label>
            <div className="k-form-field-wrap">
              <input
                disabled={true}
                name="NumberOfRows"
                id="NumberOfRows"
                className="k-input k-input-md k-rounded-md k-input-solid"
                value={pageState.formValues.NumberOfRows || ""}
              />
            </div>
          </div>
          <div className="k-form-field">
            <label className="k-label k-text-disabled">{t("datasets.importdataset.datasize")}</label>
            <div className="k-form-field-wrap">
              <input
                disabled={true}
                name="DataSize"
                id="DataSize"
                className="k-input k-input-md k-rounded-md k-input-solid"
                value={pageState.formValues.DataSize / 1024 || ""}
              />
            </div>
          </div>
          <div className="k-form-field">
            <label className="k-label k-text-disabled">
              {t("datasets.importdataset.consumption")}
            </label>
            <div className="k-form-field-wrap">
              <input
                disabled={true}
                name="RestOfConsumption"
                id="RestOfConsumption"
                className="k-input k-input-md k-rounded-md k-input-solid"
                value={pageState.formValues.RestOfConsumption / 1024 || ""}
                style={{ marginBottom: "30px" }}
              />
            </div>
          </div>
        </div>
      )}

      {formValues.ImportFrom === "fromfile" && (
        <div className="form-group form-group-1">
          <div className="k-form-field">
            <label className="k-label k-text-disabled">{t("datasets.importdataset.files1")}</label>
            <div className="k-form-field-wrap">
              <input
                disabled={true}
                name="Filename"
                id="Filename"
                className="k-input k-input-md k-rounded-md k-input-solid"
                value={pageState.formValues.Filename || ""}
              />
            </div>
          </div>
          <Field
            id={"SelectedSheet"}
            name={"SelectedSheet"}
            label={t("datasets.importdataset.sheets")}
            component={FormInput}
            disabled
          />
          <div className="k-form-field">
            <label className="k-label k-text-disabled">{t("datasets.importdataset.rows")}</label>
            <div className="k-form-field-wrap">
              <input
                disabled={true}
                name="NumberOfRows"
                id="NumberOfRows"
                className="k-input k-input-md k-rounded-md k-input-solid"
                value={pageState.formValues.NumberOfRows || ""}
              />
            </div>
          </div>
        </div>
      )}

      {formValues.ImportFrom === "fromapi" && (
        <div className="form-group form-group-1">
          <Field
            id={"Url"}
            name={"Url"}
            label={t("datasets.importdataset.url1")}
            component={FormInput}
            disabled
          />
          <Field
            id={"Method"}
            name={"Method"}
            label={t("datasets.importdataset.method1")}
            component={FormInput}
            disabled
          />
          <Field
            id={"ReccursEvery"}
            name={"ReccursEvery"}
            label={t("datasets.importdataset.recurs1")}
            disabled
            component={FormDropDownList}
            data={timeIntervalsDDL}
            dataItemKey="Id"
            textField="Title"
            className="mb30"
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "30px 0",
            }}
          >
            <label id="Headers_label" htmlFor="Headers" className="k-label">
             {t("datasets.importdataset.headers")}
            </label>
            <div className="headers-container">
              {formValues.Headers?.map((header, index) => (
                <div
                  key={`header-${index}`}
                  style={{
                    display: "flex",
                    marginBottom: "15px",
                  }}
                >
                  <Field
                    component={FormInput}
                    id={`Headers[${index}].key`}
                    name={`Headers[${index}].key`}
                    label={t("datasets.importdataset.key")}
                    value={header.key}
                    disabled
                  />
                  <Field
                    component={FormInput}
                    id={`Headers[${index}].value`}
                    name={`Headers[${index}].value`}
                    label={t("datasets.importdataset.value")}
                    value={header.value}
                    disabled
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="k-form-field">
            <label className="k-label k-text-disabled">{t("datasets.importdataset.rows")}</label>
            <div className="k-form-field-wrap">
              <input
                disabled={true}
                name="NumberOfRows"
                id="NumberOfRows"
                className="k-input k-input-md k-rounded-md k-input-solid"
                value={pageState.formValues.NumberOfRows || ""}
              />
            </div>
          </div>
          <div className="k-form-field">
            <label className="k-label k-text-disabled">{t("datasets.importdataset.datasize")}</label>
            <div className="k-form-field-wrap">
              <input
                disabled={true}
                name="DataSize"
                id="DataSize"
                className="k-input k-input-md k-rounded-md k-input-solid"
                value={pageState.formValues.DataSize / 1024 || ""}
              />
            </div>
          </div>
          <div className="k-form-field">
            <label className="k-label k-text-disabled">
              {t("datasets.importdataset.consumption")}
            </label>
            <div className="k-form-field-wrap">
              <input
                disabled={true}
                name="RestOfConsumption"
                id="RestOfConsumption"
                className="k-input k-input-md k-rounded-md k-input-solid"
                value={pageState.formValues.RestOfConsumption / 1024 || ""}
                style={{ marginBottom: "30px" }}
              />
            </div>
          </div>
        </div>
      )}

      {formValues.ImportFrom !== "fromfile" && (
        <CollapsableFormRegion
          className="form-region-main"
          title={t("datasets.importdataset.datasample")}
          open={pageState.formValues.DataSampleOpen}
          onToggle={(e) =>
            dispatch(
              setFormValue({
                id: "DataSampleOpen",
                value: !pageState.formValues.DataSampleOpen,
              })
            )
          }
        >
          <DatasetSample />
        </CollapsableFormRegion>
      )}

      <style>
        {`
          .headers-container {
            padding: 20px;
            border: ${currentTheme.managerBorder};
            display:flex;
            flex-direction:column;
          }
          .datasets-page > .content .headers-container .k-form-field {
            margin-top: 0 !important;
          }
          .datasets-page > .content .headers-container .k-button {
            height: 30px;
            margin-top: 24px;
          }
        `}
      </style>
    </FormRegion>
  );
};

export default ReviewStep;
